import { useEffect } from 'react'

type PageMetaOptions = {
  title: string
  description?: string
}

const upsertMetaTag = (selector: string, attributes: Record<string, string>) => {
  let element = document.head.querySelector<HTMLMetaElement>(selector)

  if (!element) {
    element = document.createElement('meta')
    document.head.appendChild(element)
  }

  Object.entries(attributes).forEach(([key, value]) => {
    element?.setAttribute(key, value)
  })
}

export function usePageMeta({ title, description }: PageMetaOptions) {
  useEffect(() => {
    document.title = title

    if (!description) {
      return
    }

    upsertMetaTag('meta[name="description"]', {
      name: 'description',
      content: description,
    })

    upsertMetaTag('meta[property="og:title"]', {
      property: 'og:title',
      content: title,
    })

    upsertMetaTag('meta[property="og:description"]', {
      property: 'og:description',
      content: description,
    })

    upsertMetaTag('meta[name="twitter:title"]', {
      name: 'twitter:title',
      content: title,
    })

    upsertMetaTag('meta[name="twitter:description"]', {
      name: 'twitter:description',
      content: description,
    })
  }, [title, description])
}